import type { RuntimeEnvironment } from '@/services/print/printTypes';

/**
 * Detecta de forma robusta y centralizada el entorno de ejecución.
 *
 * - ELECTRON: existe el bridge seguro expuesto por el preload mediante contextBridge.
 * - WEB: cualquier navegador (Chrome, Edge, Safari, Firefox, etc.).
 *
 * No se usa en ningún componente una comprobación directa de window.electronAPI:
 * todos deben pasar por esta utilidad para mantener una única fuente de verdad.
 */
export function getRuntimeEnvironment(): RuntimeEnvironment {
  if (
    typeof window !== 'undefined' &&
    window.electronAPI &&
    typeof window.electronAPI.getPrinters === 'function'
  ) {
    return 'ELECTRON';
  }
  return 'WEB';
}

export function isElectron(): boolean {
  return getRuntimeEnvironment() === 'ELECTRON';
}

export function isWeb(): boolean {
  return getRuntimeEnvironment() === 'WEB';
}